import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("l3_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

const ASSET = "https://customer-assets-4nw71qhi.emergentagent.net/job_eba64d41-7845-4d14-9b5f-13ea5362ddb3/artifacts/";
export const IMAGES = {
  logo: ASSET + "866a57deb878692d_IMG_6487.jpeg",
  mix: ASSET + "7def9c42d71a3572_IMG_6486.jpeg",
  ring: ASSET + "5bc296fa9ea85f90_IMG_6489.jpeg",
  letter: ASSET + "91b607ef01647fbd_IMG_6488.jpeg",
};

export const imgSrc = (url) => (url && url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url);
export const money = (n) => `$${Number(n || 0).toFixed(2)}`;
export const CATEGORIES = ["Strawberries", "Gift Boxes", "Popcorn", "Cake Mixes", "More"];

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}
